import { ui } from '@procuros/datachecks';
import isEqual from 'lodash/isEqual';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { IntegrationProcessDTO, IssueResolverType, ProcessSpecificationDTO } from 'support/types';

type State = {
  uiConfig: Array<ui.Section>;
  initialCanonical: Record<string, any> | undefined;
  isLoading: boolean;
  isValidating: boolean;
  isValidationComplete: boolean;
  isBigMessage: boolean;
  rawErrorCount: number;
  processSpecificationFields: ProcessSpecificationDTO['fields'] | undefined;
  destinationProcess: IntegrationProcessDTO | undefined | null;
  issueResolver: IssueResolverType | undefined;
};

export const initialState: State = {
  uiConfig: [],
  isLoading: true,
  isValidating: false,
  isValidationComplete: false,
  isBigMessage: false,
  rawErrorCount: 0,
  processSpecificationFields: undefined,
  initialCanonical: undefined,
  destinationProcess: undefined,
  issueResolver: undefined,
};

export const useWebEDIStore = create(
  immer<State>(() => ({
    ...initialState,
  })),
);

export const setIsValidating = (isValidating: boolean) => useWebEDIStore.setState({ isValidating });
export const setIsValidationComplete = (isValidationComplete: boolean) =>
  useWebEDIStore.setState({ isValidationComplete });
export const setIsBigMessage = (isBigMessage: boolean) => useWebEDIStore.setState({ isBigMessage });
export const setRawErrorCount = (rawErrorCount: number) => useWebEDIStore.setState({ rawErrorCount });
export const setInitialCanonical = (initialCanonical: Record<string, any> | undefined) =>
  useWebEDIStore.setState({ initialCanonical });
export const setUiConfig = (uiConfig: Array<ui.Section>) =>
  useWebEDIStore.setState((state) => {
    if (isEqual(state.uiConfig, uiConfig)) {
      return state;
    }
    return { uiConfig };
  });
export const setIsLoading = (isLoading: boolean) => useWebEDIStore.setState({ isLoading });
export const setProcessSpecificationFields = (
  processSpecificationFields: ProcessSpecificationDTO['fields'] | undefined,
) =>
  useWebEDIStore.setState((state) => {
    if (isEqual(state.processSpecificationFields, processSpecificationFields)) {
      return state;
    }
    return { processSpecificationFields: processSpecificationFields };
  });

export const setDestinationProcess = (destinationProcess: IntegrationProcessDTO | undefined | null) =>
  useWebEDIStore.setState({ destinationProcess });
export const setIssueResolver = (issueResolver: IssueResolverType | undefined) =>
  useWebEDIStore.setState({ issueResolver });
export const cleanStore = () => useWebEDIStore.setState(initialState);
